import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { HealthSection } from "../health/HealthSection";
import { HealthSectionHeader } from "../health/HealthSectionHeader";
import {
    getLocalized,
    HealthLang,
    LocalizedString,
} from "../health/healthTypes";
import { healthAimmaDoctorSectionContentOffset } from "../health/healthLayout";
import {
    healthBody,
    healthCardTitle,
} from "../health/healthVisualStyles";

interface EducationWhyMedicalSectionProps {
    data: DataKeys;
}

export function EducationWhyMedicalSection({
    data,
}: EducationWhyMedicalSectionProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;

    return (
        <HealthSection id="why-medical" ariaLabelledBy="why-medical-title" childPage>
            <HealthSectionHeader
                eyebrow={getLocalized(data.eyebrow as LocalizedString, hLang)}
                title={getLocalized(data.title as LocalizedString, hLang)}
                titleId="why-medical-title"
                subtitle={getLocalized(data.intro as LocalizedString, hLang)}
            />
            <div
                className={`${healthAimmaDoctorSectionContentOffset} grid gap-6 lg:grid-cols-2`}
            >
                <div className="rounded-xl border border-grey-100 bg-white p-5 text-left shadow-sm">
                    <h3 className={healthCardTitle}>
                        {getLocalized(data.challengesTitle as LocalizedString, hLang)}
                    </h3>
                    <ul className="mt-3 list-outside list-disc space-y-2 pl-5 text-left text-sm text-grey-600">
                        {((data.challenges as DataKeys[]) ?? []).map((item, i) => (
                            <li key={i} className="text-left leading-relaxed">
                                {getLocalized(item as LocalizedString, hLang)}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="rounded-xl border border-teal-100 bg-teal-50/40 p-5 text-left shadow-sm">
                    <h3 className={healthCardTitle}>
                        {getLocalized(data.responseTitle as LocalizedString, hLang)}
                    </h3>
                    <ul className="mt-3 list-outside list-disc space-y-2 pl-5 text-left text-sm text-grey-600">
                        {((data.responses as DataKeys[]) ?? []).map((item, i) => (
                            <li key={i} className="text-left leading-relaxed">
                                {getLocalized(item as LocalizedString, hLang)}
                            </li>
                        ))}
                    </ul>
                    <p className={`${healthBody} mt-4 text-sm italic text-grey-700`}>
                        {getLocalized(data.quote as LocalizedString, hLang)}
                    </p>
                </div>
            </div>
        </HealthSection>
    );
}
